import React from "react";
import {Redirect, Route} from "react-router-dom";
import {ReactSession} from "react-client-session";

export default function AuthenticatedRoute({children, ...rest}) {
    return (
        <Route {...rest}>
            {ReactSession.get("loggedIN") ? (
                children
            ) : (
                <Redirect to={
                    `/`
                }/>
            )}
        </Route>
    );
}
